<template>
  <footer class="app-footer">
    <span class="d-sm-down-none"><a href="javascript:void(0);"><strong>Backoffice</strong></a> | Version {{version}}</span>
    <span class="float-right">Powered by <a href="http://www.jeugenio.com.br"><strong>JEUGENIO IT</strong></a> Consulting and Solutions &nbsp;&nbsp;</span>
  </footer>
</template>
<script>
export default {
  name: 'AppFooter',
  data () {
    return {
      version: process.env.VersionApp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/layout/Footer.vue